 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		28: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		28: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","1":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","2":"productoverviewaccordiontitle~quick-view","3":"productoverviewaccordiontitle~write-a-review-form","4":"quick-view~write-a-review-form","5":"StoreLayout","6":"aislebay","7":"augmentedreality","8":"botprompt","9":"calculator-pipcalculator","10":"common","11":"consumercardmessaging","12":"customer-image-overlay","14":"globalcustomconfigurator","15":"hammerjs","16":"measurement-guide-overlay-content","17":"media-gallery-filmstrip-mobile","18":"media-gallery-overlay","19":"media-gallery-overlay-mobile","20":"order-sample-drawer","21":"ordersample","22":"overlay","23":"page","24":"productoverviewaccordiontitle","25":"promotion-products-lazy","26":"quick-view","27":"returnsmessaging","29":"share-to-email-overlay","30":"share-to-pinterest-overlay","31":"size-guide-overlay","32":"supersku","34":"video-player","35":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"707084e45a72c18067c6","1":"99fc0465729e9687bb76","2":"b154eed0ae07e2e76b2c","3":"46c6dae359705c44d960","4":"1f52450b6a6baa4d9d88","5":"7c177933173d033ee817","6":"ceb5aedea91e57dbc6d3","7":"7d0f80c1ec652851640c","8":"64ced95c29208bd08992","9":"a25769a5212e24245678","10":"8b4de751f3b0f6cc2e39","11":"a6bc995daef943b28763","12":"cae7163b4ccee6894e5e","14":"3b084a7d2b33ca9fbf9a","15":"e91631368b908f7fd6e0","16":"e27432278e2c4bd65c74","17":"8d1938d08a1c1ff5c5c8","18":"acb774cd8103b174b2b6","19":"7e2c156021c2da7047ca","20":"cbb6f6766ffff47d7a7f","21":"0fe547b5f516cce06dcd","22":"bf2f8d0807012ce77970","23":"086aebac111e5758b075","24":"f44368d0b29bc93baf15","25":"56d8e3d905996f67e6a9","26":"50d11ff49f5648df66ec","27":"2aaa184b1a27d1ce721b","29":"41c2f4d2bf2f4734c6b5","30":"871fd2a5fdce1ea6a70f","31":"7273eb22670603ffb71d","32":"f37419771599a3f9564b","34":"dc51a62988746b72a2a6","35":"6aa561e2ab042a38ea86","36":"60d3b43a540b9a495888"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"2":1,"3":1,"4":1,"6":1,"8":1,"11":1,"12":1,"14":1,"17":1,"18":1,"19":1,"22":1,"23":1,"24":1,"25":1,"26":1,"32":1,"34":1,"35":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","1":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","2":"productoverviewaccordiontitle~quick-view","3":"productoverviewaccordiontitle~write-a-review-form","4":"quick-view~write-a-review-form","5":"StoreLayout","6":"aislebay","7":"augmentedreality","8":"botprompt","9":"calculator-pipcalculator","10":"common","11":"consumercardmessaging","12":"customer-image-overlay","14":"globalcustomconfigurator","15":"hammerjs","16":"measurement-guide-overlay-content","17":"media-gallery-filmstrip-mobile","18":"media-gallery-overlay","19":"media-gallery-overlay-mobile","20":"order-sample-drawer","21":"ordersample","22":"overlay","23":"page","24":"productoverviewaccordiontitle","25":"promotion-products-lazy","26":"quick-view","27":"returnsmessaging","29":"share-to-email-overlay","30":"share-to-pinterest-overlay","31":"size-guide-overlay","32":"supersku","34":"video-player","35":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"59d72f4e8c0806257828","1":"31d6cfe0d16ae931b73c","2":"0c67c1ae01971c004ded","3":"3764a4aa9824f0179dd1","4":"eb9ae1e50def6cce9643","5":"31d6cfe0d16ae931b73c","6":"d94b956aa532c1a50c65","7":"31d6cfe0d16ae931b73c","8":"4be99b2862037eff2a09","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"b71f8ffaebe49e5b8650","12":"793c6b0097016277822f","14":"1a5562a08d12f7682989","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"5145b703af77d63ef858","18":"fa175eb867e0083b7955","19":"55dcaf86d839d88ccce2","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"f8f0bd5d775377b9097c","23":"9bd9bd3ed6337c142c7c","24":"254ccce7e32ec1958df1","25":"ee58265e369789fb3e9c","26":"35599878ff35ca6caad1","27":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"b31101625f385d3bcc30","34":"4f5b608ec38d0792d47e","35":"7c2eed0c18c49e42c517","36":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/fusion-hdh-pip-mobile/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
